import alanyaspor from "../images/logos/alanyaspor-logo.png";
import antalyaspor from "../images/logos/antalyaspor-logo.png";
import basaksehir from "../images/logos/basaksehir-logo.png";
import besiktas from "../images/logos/besiktas-logo.png";
import eyupspor from "../images/logos/eyupspor-logo.png";
import fatihKaragumruk from "../images/logos/fatih-karagumruk-logo.png";
import fenerbahce from "../images/logos/fenerbahce-logo.png";
import galatasaray from "../images/logos/galatasaray-logo.png";
import gaziantepFK from "../images/logos/gaziantep-fk-logo.png";
import genclerbirligi from "../images/logos/genclerbirligi-logo.png";
import goztepe from "../images/logos/goztepe-logo.png";
import kasimpasa from "../images/logos/kasimpasa-logo.png";
import kayserispor from "../images/logos/kayserispor-logo.png";
import kocaelispor from "../images/logos/kocaelispor-logo.png";
import konyaspor from "../images/logos/konyaspor-logo.png";
import trabzonspor from "../images/logos/trabzonspor-logo.png";
import rizespor from "../images/logos/rizespor-logo.png";
import samsunspor from "../images/logos/samsunspor-logo.png";

export const logos = {
  alanyaspor: alanyaspor,
  antalyaspor: antalyaspor,
  basaksehir: basaksehir,
  besiktas: besiktas,
  eyupspor: eyupspor,
  "fatih-karagumruk": fatihKaragumruk,
  fenerbahce: fenerbahce,
  galatasaray: galatasaray,
  "gaziantep-fk": gaziantepFK,
  genclerbirligi: genclerbirligi,
  goztepe: goztepe,
  kasimpasa: kasimpasa,
  kayserispor: kayserispor,
  kocaelispor: kocaelispor,
  konyaspor: konyaspor,
  trabzonspor: trabzonspor,
  samsunspor: samsunspor,
  rizespor: rizespor,
};

export const logosForFullName = {
  Alanyaspor: alanyaspor,
  Antalyaspor: antalyaspor,
  Başakşehir: basaksehir,
  Beşiktaş: besiktas,
  Eyüpspor: eyupspor,
  "Fatih Karagümrük": fatihKaragumruk,
  Fenerbahçe: fenerbahce,
  Galatasaray: galatasaray,
  "Gaziantep FK": gaziantepFK,
  Gençlerbirliği: genclerbirligi,
  Göztepe: goztepe,
  Kasımpaşa: kasimpasa,
  Kayserispor: kayserispor,
  Kocaelispor: kocaelispor,
  Konyaspor: konyaspor,
  Trabzonspor: trabzonspor,
  Samsunspor: samsunspor,
  Rizespor: rizespor,
};
